import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {VetineoVisitTypeCategory} from "../../models/vetineo-visit-type-category.model";
import {VetClinic} from "../../models/vet-clinic.model";

@Component({
  selector: 'app-vet-doctor-visit-types-inconsistencies',
  templateUrl: './vet-doctor-visit-types-inconsistencies.component.html',
  styleUrls: ['./vet-doctor-visit-types-inconsistencies.component.scss'],
})
export class VetDoctorVisitTypesInconsistenciesComponent implements OnInit {


  @Input() visitTypeOptions;
  @Input() vetineoVisitTypeCategoriesForVetcode: VetineoVisitTypeCategory[];
  @Input() vetClinic: VetClinic;
  title: string = 'Wykryto niespójności w typach wizyt lekarzy';
  csvDownloaded: boolean = false;
  selectedOptions: {
    [visitTypeUuid: string]: {
      description?: string;
      cancellationTime?: number;
      requireCancellationReason?: boolean;
    };
  } = {};

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    this.autoSelectSingleOptions();
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  onSubmit() {
    if (this.csvDownloaded) {
      this.normalizeDescriptions();
      this.modalController.dismiss(this.selectedOptions);
    } else {
      this.exportToCsv();
    }
  }

  autoSelectSingleOptions(): void {
    this.visitTypeOptions.forEach(item => {
      if (!this.selectedOptions[item.uuid]) {
        this.selectedOptions[item.uuid] = {};
      }

      const opt = this.selectedOptions[item.uuid];

      if (
        Array.isArray(item.descriptions) &&
        item.descriptions.length === 1 &&
        opt.description === undefined
      ) {
        opt.description = item.descriptions[0].value;
      }

      if (
        Array.isArray(item.cancellationTimes) &&
        item.cancellationTimes.length === 1 &&
        opt.cancellationTime === undefined
      ) {
        opt.cancellationTime = item.cancellationTimes[0].value;
      }

      if (
        (!Array.isArray(item.descriptions) || item.descriptions.length === 0) &&
        (!Array.isArray(item.cancellationTimes) || item.cancellationTimes.length === 0)
      ) {
      }
    });
  }

  normalizeDescriptions(): void {
    Object.keys(this.selectedOptions).forEach(uuid => {
      const opt = this.selectedOptions[uuid];

      if (opt.description === '-') {
        opt.description = null;
      }
    });
  }

  onDescriptionSelect(visitTypeUuid: string, value: string) {
    if (!this.selectedOptions[visitTypeUuid]) {
      this.selectedOptions[visitTypeUuid] = {};
    }

    this.selectedOptions[visitTypeUuid].description = value;
    this.csvDownloaded = false;
  }

  onCancellationSelect(visitTypeUuid: string, value: number) {
    if (!this.selectedOptions[visitTypeUuid]) {
      this.selectedOptions[visitTypeUuid] = {};
    }

    this.selectedOptions[visitTypeUuid].cancellationTime = value;
    this.csvDownloaded = false;


  }

  onCancellationReasonSelect(visitTypeUuid: string) {
    if (!this.selectedOptions[visitTypeUuid]) {
      this.selectedOptions[visitTypeUuid] = {};
    }

    this.selectedOptions[visitTypeUuid].requireCancellationReason = !this.selectedOptions[visitTypeUuid].requireCancellationReason;
  }

  getSubmitTitle() {
    return this.csvDownloaded ? 'potwierdzam zmiany' : 'pobierz csv';
  }

  getDesc(desc: any) {
    return desc? desc.value? desc.value : 'brak opisu' : 'brak opisu';
  }

  listToCommaString(list: string[]): string {
    return list.join(' | ');
  }

  exportToCsv(): void {
    const headers = ['nazwa typu', 'lekarz', 'czas trwania', 'info', 'czy można anulować', 'czas na anulowanie', 'czy wymaga powodu anulowania','gatunki','kategoria'];
    const rows: string[] = [];

    for (const category of this.vetineoVisitTypeCategoriesForVetcode) {
      for (const type of category?.subcategories) {
        if (type && type.bundle && type.bundle.vetDoctorVetVisitTypes) {
          for (const c of type?.bundle?.vetDoctorVetVisitTypes) {
            const allPetSpecies = c.allPetSpecies;
            let servedPetSpecies = this.listToCommaString(c.servedPetSpecies.map(e=>e.name));
            if (allPetSpecies) {
              servedPetSpecies = 'wszystkie'
            }
            rows.push(
              `"${c.namePL}";"${c.vetDoctor?.name}";"${c.minutes}";"${c.infoPL ? c.infoPL : ''}"; "${c.termCanBeCancelled ? 'tak' : 'nie'}"; "${c.maxTermCancellation ? c.maxTermCancellation : ''}"; ${c.requireCancellationReason ? 'tak' : 'nie'}; ${servedPetSpecies}; "${category.name}"`
            );
          }
        }

      }
    }

    const csvContent =
      `"${headers.join('";"')}"\n` +
      rows.join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${this.vetClinic.vetcodeId}.csv`;
    link.click();

    URL.revokeObjectURL(url);
    setTimeout( () => {
      this.csvDownloaded = true;
    }, 600);
  }


  logTest (){
    this.normalizeDescriptions()
    console.log(this.selectedOptions)

  }

  validateSelectedOptions(): boolean {
    let allValid = true;

    this.visitTypeOptions.forEach(item => {
      const selected = this.selectedOptions[item.uuid];

      if (!selected) {
        if ((item.descriptions?.length || 0) > 0 || (item.cancellationTimes?.length || 0) > 0) {
          allValid = false;
        }
        return;
      }

      if ((item.descriptions?.length || 0) > 0) {
        if (!selected.description) {
          allValid = false;
          return false;
        }
      }

      if ((item.cancellationTimes?.length || 0) > 0) {
        if (selected.cancellationTime === undefined) {
          allValid = false;
          return false;
        }
      }
    });

    return allValid;
  }

  onCancellationReasonToggle(uuid: string, checked: boolean): void {
    if (!this.selectedOptions[uuid]) {
      this.selectedOptions[uuid] = {};
    }

    this.selectedOptions[uuid].requireCancellationReason = checked;
    this.csvDownloaded = false;
  }

  getTimeValue(value: any) {
    if (value) {
      return value+ ' godzin';
    } else {
      return 'brak czasu na anulację'
    }
  }
}
